import React, {createContext, useContext, useState} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ModalContext = createContext();

export function toastSaveSuccessful() {
    toast("Úspešne uložené!");
}


export function useModal() {
    return useContext(ModalContext);
}

export function ModalProvider({children}) {
    const [modalConfig, setModalConfig] = useState({
        ModalComponent: null,
        show: false,
        text: '',
        onConfirm: () => {
        },
    });

    const showModal = (dialogType, text, onConfirm) => {
        setModalConfig({ModalComponent: dialogType, show: true, text, onConfirm});
    };

    const hideModal = () => {
        setModalConfig({...modalConfig, show: false});
    };

    const confirmModal = (action) => {
        hideModal();
        modalConfig.onConfirm(action);
    };

    return (
        <ModalContext.Provider value={{showModal, hideModal, confirmModal}}>
            {/*<ToastContainer position="bottom-center" hideProgressBar={true}/>*/}
            <ToastContainer position="bottom-center" autoClose={2000} hideProgressBar={true}/>
            {children}
            {modalConfig.ModalComponent &&
                <modalConfig.ModalComponent show={modalConfig.show} text={modalConfig.text} onHide={hideModal}
                                            onConfirm={confirmModal}/>
            }
        </ModalContext.Provider>
    );
}